import React from 'react'
import Navbar from '../components/Global/Navbar'
import Main from '../components/Manage/Main'

class Manage extends React.Component {
	render() {
		
		const { match } = this.props
		
		return (
			<div>
				<Navbar />
				<Main pathname={ match } />
			</div>
		)
	}
}

export default Manage


// WEBPACK FOOTER //
// ./src/containers/Manage.js